import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useContext, useEffect, useState } from 'react'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'
import Video from '../Video/Video'
import CardDestaque from './CardDestaque/CardDestaque'
import CardDiscreto from './CardDiscreto/CardDiscreto'

const AcessosAoVivo = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)

    const [acessos, setAcessos] = useState([])
    const [openVideo, setOpenVideo] = useState(false)
    const [titleVideo, setTitleVideo] = useState("")
    const [acessoId, setAcessoId] = useState("")
    const [cameraId, setCameraId] = useState("")

    const openModalVideo = () => {
        setOpenVideo(true)
    }

    const openVideoFunction = (idAcesso, cameraId) => {
        setAcessoId(idAcesso)
        setTitleVideo('Camêra - Acesso')
        setCameraId(cameraId)
        setTimeout(() => {
            openModalVideo()
        }, 10)
    }

    const getAcesso = (msg) => {
        if (msg.data.id_central !== activeCond.id_central) return
        const newAcesso = msg.data
        const data = new Date(newAcesso.data).toLocaleString('pt-BR').replace(',', ' ')
        newAcesso.data = data
        newAcesso.descAcesso = newAcesso.acesso
        delete newAcesso.acesso
        const novosAcessos = [newAcesso, ...acessos]
        setAcessos(novosAcessos)
    }

    const getAcessosAoVivo = (msg) => {
        if (msg.data.filtros.maisAcessos) {
            const novosAcessos = [...acessos, ...msg.data.acessos]
            setAcessos(novosAcessos)
        } else {
            setAcessos(msg.data.acessos)
        }
    }

    addRoute('oneacessos', getAcesso)
    addRoute('getAcessosAoVivo', getAcessosAoVivo)
    useEffect(() => {
        sendWs('getAcessosAoVivo', { filtros: { id_central: activeCond.id_central, qnt_reg: 10, maisAcessos: false } })
        sendWs('setIdAcessos', { id_central: activeCond.id_central })
        return () => {
            sendWs('setIdAcessos', { id_central: 0 })
        }
    }, [activeCond])

    const buscarMaisAcessos = () => {
        sendWs('getAcessosAoVivo', { filtros: { id_central: activeCond.id_central, qnt_reg: 10, ult_reg: acessos[acessos.length - 1].id, maisAcessos: true } })
    }

    return (
        <>
            <button id="acessosAoVivoGetDados" style={{ display: 'none' }} onClick={() => sendWs('getAcessosAoVivo', { filtros: { id_central: activeCond.id_central, qnt_reg: 10, maisAcessos: false } })} >Buscar mais</button>
            {openVideo &&
            <Video
                open={openVideo}
                setOpen={setOpenVideo}
                title={titleVideo}
                eventId={acessoId}
                cameraId={cameraId}
            />
            }
            <Box container sx={{
                gap: '7px',
                alignItems: 'self-start',
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            }} >
                <Grid container gap={6} item sx={{ padding: '5px' }}>
                    <Grid item><span style={{ fontWeight: 600, fontSize: '17px' }}>Acessos ao Vivo</span></Grid>
                    <Grid item container gap={2}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: 'auto',
                            flexWrap: 'nowrap'
                        }}>
                        <Grid container item gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ backgroundColor: '#0FBB00', width: '11px', height: '11px', borderRadius: '2px' }} ></div>
                            <span style={{ fontSize: '11px' }}>Usuário</span>
                        </Grid>
                        <Grid container item gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ backgroundColor: '#FB9B0C', width: '11px', height: '11px', borderRadius: '2px' }} ></div>
                            <span style={{ fontSize: '11px' }}>Visitante</span>
                        </Grid>
                        <Grid container item gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ backgroundColor: '#FF0000', width: '11px', height: '11px', borderRadius: '2px' }} ></div>
                            <span style={{ fontSize: '11px' }}>Acesso Negado</span>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} sx={{
                    width: '100%',
                    display: 'flex',
                    overflowY: 'hidden',
                    flexGrow: 1
                }}>
                    <Grid container
                        sx={{
                            height: '100%',
                            width: '100%',
                            backgroundColor: '#D9D9D9',
                            borderRadius: '5px',
                            padding: '5px',
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            justifyContent: 'center'
                        }}
                        gap={0.5}
                    >
                        {acessos.length > 0 && acessos.map((acesso, index) => {
                            if (index === 0) {
                                return (
                                    <CardDestaque
                                        key={index}
                                        acesso={acesso}
                                        openVideoFunction={openVideoFunction}
                                        idCentral={activeCond.id_central}
                                    />
                                )
                            } else {
                                return (
                                    <CardDiscreto
                                        key={index}
                                        acesso={acesso}
                                        openVideoFunction={openVideoFunction}
                                        idCentral={activeCond.id_central}
                                    />
                                )
                            }
                        })}
                        <Typography sx={{ fontSize: '15px', fontWeight: 600, cursor: 'pointer' }} onClick={() => buscarMaisAcessos()} >Mostar +</Typography>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export default AcessosAoVivo
